import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { ProposalProvider, DisplayProvider, DisplayInfo } from '../types/Components';
import type Action from '../lib/Action';
import type { Proposal } from '../lib/Proposal';
import { HexBearing } from '../grid';
import HexPosition from './HexPosition';
import { ActionType } from '../lib/Action';
import { ProposalType } from '../lib/Proposal';

/**
 * An ability that lets an actor attack an opponent to its side as it moves forward.
 */
class SideSwipe extends Component implements ProposalProvider, DisplayProvider {
  bearingOffset: number;
  damage: number;
  priority: number;

  constructor(data: { bearingOffset?: number, damage?: number, priority?: number } = {}) {
    super();
    this.bearingOffset = data.bearingOffset ?? 0;
    this.damage = data.damage ?? 100;
    this.priority = data.priority ?? 50;
  }

  getDisplayInfo(): DisplayInfo {
    return { icon: 'game-icons:spinning-sword', label: 'Side Swipe', description: 'Attacks the hex to the side.' };
  }

  getProposedOutcome(selfAction: Action): Proposal | null {
    if (selfAction.type !== ActionType.MOVE || !selfAction.details.coords) {
      return null;
    }

    const selfPos = selfAction.entity.getComponent(HexPosition);
    if (!selfPos) return null;

    const targetBearing = HexBearing.next(selfPos.bearing, this.bearingOffset);
    const targetHex = selfPos.coords.neighbor(targetBearing);

    const effect = {
      type: 'ATTACK' as const,
      attackHex: targetHex,
      damage: this.damage,
      attackTiming: 'ANY' as const,
      animationMergeStrategy: 'REPLACE' as const,
      animationPlan: [[{
        type: 'MOVE_SWIPE',
        entityId: selfAction.entity.id,
        targetCoords: selfAction.details.coords,
        swipeCoords: targetHex,
      }]],
    };

    return {
      type: ProposalType.AUGMENT,
      priority: this.priority,
      effects: [effect],
    };
  }
}

export default simpleComponent(SideSwipe);
